import { Injectable } from '@angular/core';
import { ParentService } from '../A2-utils/ParentClass/ParentService';
import { Http } from '@angular/http';
import { Router } from '@angular/router';
import {constant} from '../../app.constants';
import { Observable } from 'rxjs';

@Injectable()
export class ReportsService extends ParentService {

  constructor(private _http: Http, private route: Router) {
    super()
    this.verifyToken(this._http, route);
   }
}



// WEBPACK FOOTER //
// ./src/app/pages/reports/reports.service.ts